export default class FactBox {
    constructor(elm, args) {
        const readMoreButton = elm.querySelector('.factbox-macro__read-more');
        const fadeOut = elm.querySelector('.factbox-macro__fade-out');
        const textBody = elm.querySelector('.factbox-macro__body');

        if (textBody.offsetHeight > 70) {
            readMoreButton.style.display = 'block';
            fadeOut.style.display = 'block';
        }

        readMoreButton.addEventListener('click', () => {
            textBody.style.maxHeight = 'max-content';
            readMoreButton.style.display = 'none';
            fadeOut.style.display = 'none';
            elm.classList.remove('factbox-macro--hidden')
        })
    }
}
